/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Input for the AI questionnaire prefill agent (one target question).
 *
 * Only IDs are accepted from the client. The question's text, type, options,
 * step, and questionnaire are resolved from the ``question_id`` row in the
 * view, so the prompt content is tied to the real database row and cannot be
 * spoofed or drift from a stale client copy.
 * @export
 * @interface PrefillRequest
 */
export interface PrefillRequest {
  /**
   *
   * @type {number}
   * @memberof PrefillRequest
   */
  useCaseId: number;
  /**
   *
   * @type {number}
   * @memberof PrefillRequest
   */
  questionId: number;
}

/**
 * Check if a given object implements the PrefillRequest interface.
 */
export function instanceOfPrefillRequest(value: object): value is PrefillRequest {
  if (!('useCaseId' in value) || value['useCaseId'] === undefined) return false;
  if (!('questionId' in value) || value['questionId'] === undefined) return false;
  return true;
}

export function PrefillRequestFromJSON(json: any): PrefillRequest {
  return PrefillRequestFromJSONTyped(json, false);
}

export function PrefillRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrefillRequest {
  if (json == null) {
    return json;
  }
  return {
    useCaseId: json['use_case_id'],
    questionId: json['question_id'],
  };
}

export function PrefillRequestToJSON(value?: PrefillRequest | null): any {
  if (value == null) {
    return value;
  }
  return {
    use_case_id: value['useCaseId'],
    question_id: value['questionId'],
  };
}
